import Refresh from "@mui/icons-material/Refresh";
import { IconButton, LinearProgress } from "@mui/material";
import { PageHeader, Toolbar } from "common";
import useHeaderHeight from "helpers/useHeaderHeight";
import I18n from "i18n";
import { useCoordinatorReport2DataContext } from "../useCoordinatorReport2Data";

export default function CoordinatorReport2Header() {
  const { load, loading } = useCoordinatorReport2DataContext();
  const headerHeight = useHeaderHeight();

  return (
    <>
      <PageHeader title={I18n.t("CoordinatorReport2.title")}>
        <Toolbar sx={{ gap: 1 }}>
          <IconButton onClick={load}>
            <Refresh />
          </IconButton>
        </Toolbar>
      </PageHeader>
      {loading && (
        <LinearProgress
          sx={{ position: "fixed", left: 0, top: headerHeight, right: 0 }}
        />
      )}
    </>
  );
}
